import type { VariantProps } from 'class-variance-authority'

import { Button as ButtonPrimitive } from '@base-ui/react/button'
import { cva } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const buttonVariants = cva(
    "group/button inline-flex shrink-0 items-center justify-center rounded-full border border-transparent bg-clip-padding font-semibold whitespace-nowrap transition-all outline-none select-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 active:not-aria-[haspopup]:translate-y-px disabled:pointer-events-none disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4",
    {
        variants: {
            variant: {
                default: 'bg-primary text-primary-foreground shadow-sm hover:bg-primary/90',
                gold: 'bg-gold text-gold-foreground shadow-sm hover:bg-gold/90',
                outline: 'border-border bg-background text-foreground hover:bg-secondary aria-expanded:bg-secondary',
                inverse: 'border-background/35 bg-transparent text-background hover:bg-background/10',
                secondary: 'bg-secondary text-secondary-foreground hover:bg-accent aria-expanded:bg-accent',
                ghost: 'text-foreground hover:bg-secondary aria-expanded:bg-secondary',
                destructive: 'bg-destructive/10 text-destructive hover:bg-destructive/20 focus-visible:border-destructive/40 focus-visible:ring-destructive/20',
                link: 'text-primary underline-offset-4 hover:underline'
            },
            size: {
                default: 'h-11 gap-2 px-5 text-sm',
                xs: 'h-7 gap-1 px-2.5 text-xs [&_svg:not([class*=\'size-\'])]:size-3',
                sm: 'h-9 gap-1.5 px-4 text-sm',
                lg: 'h-12 gap-2 px-7 text-base',
                icon: 'size-11',
                'icon-xs': 'size-7 [&_svg:not([class*=\'size-\'])]:size-3',
                'icon-sm': 'size-9',
                'icon-lg': 'size-12'
            }
        },
        defaultVariants: {
            variant: 'default',
            size: 'default'
        }
    }
)

function Button({
    className,
    variant = 'default',
    size = 'default',
    ...props
}: ButtonPrimitive.Props & VariantProps<typeof buttonVariants>) {
    return (
        <ButtonPrimitive
            data-slot='button'
            className={cn(buttonVariants({ variant, size, className }))}
            {...props}
        />
    )
}

export { Button, buttonVariants }
